
import api from '@/api';
import DateComponent from '@/components/DateComponent.vue';
import ShowPopup from '@/components/ShowPopup.vue';
import { cobrancaStore, companyStore, mainStore, retencaoFinanceiraStore } from '@/store';
import { addDays, differenceInDays, format, isEqual } from 'date-fns';
import _ from 'lodash';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import SendMessageSyngoo from './SendMessageSyngoo.vue';

@Component({
  components: {
    ShowPopup,
    DateComponent,
    SendMessageSyngoo,
  },
})
export default class ListTitulosSyngoo extends Vue {
  @Prop({ type: Number }) readonly propId;
  @Prop({ type: Number }) readonly propDias;
  @Prop({ type: Number, default: 0 }) readonly propStateTitulo;
  @Prop({
    type: Object,
    default: () => {},
  })
  readonly propRetencaoItem;

  @Watch('propState', { immediate: true, deep: true })
  async reloadTitulos() {
    if (this.propState > 0) {
      let response = setTimeout(async () => {
        this.$emit('getPropStateTitulo', Math.floor(Math.random() * 200));
      }, 1000);

      await this.load();

      if (this.propRetencaoItem.c014_id > 0) {
        this.unidadeDetails = await companyStore.getCompanyByC014_id(String(this.propRetencaoItem.c014_id));
      }

      // this.titulosSerasa = await juridicoStore.getTitulosSerasa(
      //   this.propRetencaoItem.c014_id
      // );
      // this.titulosCobrancaJudicial = await juridicoStore.getTitulosCobranca(
      //   this.propRetencaoItem.c014_id
      // );

      this.mensagens_titulos_syngoo = await retencaoFinanceiraStore.getMensagensEnviadasByC014_id(
        this.propRetencaoItem.c014_id
      );

      this.titulos_mensagem = this.mensagens_titulos_syngoo[0];
      this.res_titulos_mensagem = this.mensagens_titulos_syngoo[1];

      this.buscaTituloItems();
    }
  }

  public propUnidade = '';
  public textAviso = '';
  public titulos_mensagem = '';
  public res_titulos_mensagem = [];

  public status_mensagem = 0;
  public unidadeDetails = null;
  public titulosSerasa = '';
  public mensagens_titulos_syngoo = [];
  public propC014_id_unidade = 0;
  public tituloSerasaPago = '';
  public motivoNaoPagamento = [];
  public titulosCobrancaJudicial = '';
  public tituloJudicialPago = '';
  public etapaCobranca = '';
  public propTitulos = [];
  public tituloItems = [];
  public propTitle = '';
  public propTitleBtn = '';
  public propTituloAlert = '';
  public propTipo = '';
  public hoje = format(new Date(), 'yyyy-MM-dd');
  public hojeMais3 = null;
  public acaoExecutada = [];
  public titulosOptions: any[] = [];

  public tipoContato = '';

  public isLoading = false;
  public isSubmit = false;

  public propState = 0;

  public statusAux = 0;

  public created_by_id = 0;

  public company_c014id = 0;

  public descricao = '';

  public tiposFatura = 'emAberto';

  public totalDevido = 0;
  public qtdTitulosVencidos = 0;
  public c014_id = 0;
  public search = '';

  public today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

  // header do financeiro unidade
  public headersFinanceiro = [
    {
      text: 'Nº Título',
      sortable: true,
      value: 'Documento',
      align: 'left',
    },
    {
      text: 'Vencimento',
      sortable: true,
      value: 'T014_Vencimento',
      align: 'left',
    },
    {
      text: 'Data pagamento',
      sortable: true,
      value: 'T014_DataPagamento',
      align: 'left',
    },
    {
      text: 'Tipo',
      sortable: true,
      value: 'Tipo',
      align: 'left',
    },
    {
      text: 'Tipo Baixa',
      sortable: true,
      value: 'descricao',
      align: 'left',
    },
    {
      text: 'Valor original',
      sortable: true,
      value: 'valor_original',
      align: 'left',
    },
    {
      text: 'Valor atualizado',
      sortable: true,
      value: 'valor_atualizado',
      align: 'left',
    },
    // {
    //   text: "Dias Atraso",
    //   sortable: true,
    //   value: "Atraso",
    //   align: "left",
    // },
    // {
    //   text: "Serasa",
    //   sortable: true,
    //   value: "status_serasa",
    //   align: "left",
    // },
    // {
    //   text: "Cobrança Judicial",
    //   sortable: true,
    //   value: "status_judicial",
    //   align: "left",
    // },
    // {
    //   text: "Baixar Boleto",
    //   value: "baixar_boleto",
    //   align: "center",
    // },
    // {
    //   text: "Copiar Código",
    //   value: "copiar_codigo",
    //   align: "center",
    // },
    {
      text: 'Status Mensagem',
      value: 'status_mensagem',
      align: 'center',
    },
    {
      text: 'Enviar Mensagem',
      value: 'enviar_boleto',
      align: 'center',
    },
  ];

  get details() {
    return cobrancaStore.cobrancaDetails;
  }

  get userProfile() {
    return mainStore.userProfile;
  }

  get getHeader() {
    if (!this.userProfile) return;

    this.load();
    return this.headersFinanceiro;
  }

  get titulosEmAberto() {
    let item = this.tituloItems;

    item = item.filter((f) => f.data_vencimento === 'vencido');

    return item;
  }

  // get tituloItems() {
  public async buscaTituloItems() {
    let array = [];
    let titulosVencidos = [];

    //@ts-ignore
    if (!this.details.titulos || !this.details.titulos) return array;
    this.qtdTitulosVencidos = 0;
    if (this.tiposFatura === 'emAberto') this.qtdTitulosVencidos = 0;

    //@ts-ignore
    for (const a in this.details.titulos) {
      if (this.tiposFatura === 'emAberto') {
        //@ts-ignore
        const item = this.details.titulos[a];
        item['data_vencimento'] = '';
        if (item.valor_original && !item.valor_atualizado && item.valor_original !== item.valor_pago) {
          //@ts-ignore
          array.push(item);
        } else if (!item.valor_pago || (item['valor_atualizado'] && item['valor_pago'] && item.valor_atualizado > 0)) {
          //item['valor_atualizado'] && item['valor_pago']"
          if (new Date(item.T014_Vencimento) < this.today) {
            if (isEqual(new Date(item.T014_Vencimento), this.today)) {
              item['valor_atualizado'] = item.valor_original;
            }
            item['data_vencimento'] = 'vencido';
            var date1 = new Date(item.T014_Vencimento);
            var dias = differenceInDays(this.today, date1);
            item['Atraso'] = dias;

            this.qtdTitulosVencidos += 1;
            //@ts-ignore
            titulosVencidos.push(item);
          }

          if (this.titulos_mensagem.includes(item.Documento)) {
            let resumo_envio = this.res_titulos_mensagem[0];
            let resumo =
              'Tipo de Envio ' +
              (resumo_envio.tipo_aviso === 3 ? '"Três dias". ' : '"Vence hoje". ') +
              'Enviada em ' +
              format(new Date(resumo_envio.created_at), 'dd/MM/yyyy') +
              ' por ' +
              resumo_envio.created_by_name;
            item['status_mensagem'] = 1;
            item['resposavel_mensagem'] = resumo;
          } else {
            item['status_mensagem'] = 0;
            item['resposavel_mensagem'] = '';
          }
          // if (this.titulosSerasa[0].includes(item.Documento)) {
          //   this.tituloSerasaPago = item.Documento;
          //   item["status_serasa"] = "Serasa";
          //   item["titulo_serasa"] = this.getTituloSerasaPago();
          //   // item["selectable"] = false;
          // } else {
          //   item["status_serasa"] = "";
          //   item["titulo_serasa"] = "";
          //   //   item["selectable"] = true;
          // }

          // if (this.titulosCobrancaJudicial[0].includes(item.Documento)) {
          //   this.tituloJudicialPago = item.Documento;
          //   item["status_judicial"] = "Cobrança Judicial";
          //   item["titulo_judicial"] = this.getTituloJudicialPago();
          //   // item["selectable"] = false;
          // } else {
          //   item["status_judicial"] = "";
          //   item["titulo_judicial"] = "";
          //   //   item["selectable"] = true;
          // }

          // item["selectable"] = true;

          //@ts-ignore
          array.push(item);
        }
      } else {
        //@ts-ignore
        const item = this.details.titulos[a];
        item['data_vencimento'] = '';

        if (item.valor_pago >= item['valor_original']) {
          if (new Date(item.T014_Vencimento) < this.today) {
            item['data_vencimento'] = 'vencido';
          }

          if (this.titulos_mensagem.includes(item.Documento)) {
            let resumo_envio = this.res_titulos_mensagem[0];
            let resumo =
              'Tipo de Envio ' +
              (resumo_envio.tipo_aviso === 3 ? '"Três dias". ' : '"Vence hoje". ') +
              'Enviada em ' +
              format(new Date(resumo_envio.created_at), 'dd/MM/yyyy') +
              ' por ' +
              resumo_envio.created_by_name;
            item['status_mensagem'] = 1;
            item['resposavel_mensagem'] = resumo;
          } else {
            item['status_mensagem'] = 0;
            item['resposavel_mensagem'] = '';
          }

          // if (this.titulosSerasa[0].includes(item.Documento)) {
          //   this.tituloSerasaPago = item.Documento;
          //   item["titulo_serasa"] = this.getTituloSerasaPago();
          //   item["status_serasa"] = "Serasa";
          //   // item["selectable"] = false;
          // } else {
          //   item["status_serasa"] = "";
          //   //   item["selectable"] = true;
          // }
          // if (this.titulosCobrancaJudicial[0].includes(item.Documento)) {
          //   this.tituloJudicialPago = item.Documento;
          //   item["status_judicial"] = "Cobrança Judicial";
          //   item["titulo_judicial"] = this.getTituloJudicialPago();
          //   // item["selectable"] = false;
          // } else {
          //   item["status_judicial"] = "";
          //   //   item["selectable"] = true;
          // }

          // item["selectable"] = true;
          //@ts-ignore
          array.push(item);
        }
      }
    }

    // SOMA VALOR TOTAL DEVIDO E ATRASADO
    this.totalDevido = _.sum(_.map(titulosVencidos, (t) => _.toNumber(t.valor_atualizado)));

    if (this.tiposFatura === 'emAberto') {
      this.tituloItems = _.orderBy(array, ['T014_Vencimento'], ['asc']);
      // return this.tituloItems;
    } else {
      this.tituloItems = _.orderBy(array, ['T014_Vencimento'], ['desc']);
      // return this.tituloItems;
    }

    let item = [];
    item = this.tituloItems;
    if (this.propDias === 3) {
      item = item.filter((f) => format(new Date(f.T014_Vencimento), 'yyyy-MM-dd') === this.hojeMais3);
    } else {
      item = item.filter((f) => format(new Date(f.T014_Vencimento), 'yyyy-MM-dd') === this.hoje);
    }
    this.tituloItems = item;
    return this.tituloItems;
  }

  public async enviarMensagemBoleto(item) {
    let array = [];
    array.push(item);
    this.propUnidade = this.propRetencaoItem.unidade;
    this.propTitulos = array;
    this.propTitle = 'Enviar mensagem de aviso de vencimento';
    this.propTitleBtn = 'Enviar mensagem';
    this.propTituloAlert = 'Boleto';
    this.propC014_id_unidade = this.propRetencaoItem.c014_id;
    this.propTipo = 'S';
    this.propState = 0;

    let form: any = null;
    form = this.$refs.listSyngoo;
    form.show();
  }

  public async baixarBoleto(item) {
    try {
      const response = await api.getCompanyBoletos(mainStore.token, item);
      if (response) {
        const bytes = response.data;

        const blob = new Blob([bytes], { type: 'application/pdf' });
        const blobURL = window.URL.createObjectURL(blob);
        const tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', `${item.Documento}.pdf`);
        if (typeof tempLink.download === 'undefined') {
          tempLink.setAttribute('target', '_blank');
        }
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        setTimeout(() => {
          window.URL.revokeObjectURL(blobURL);
        }, 100);
      }
    } catch (e) {
      await mainStore.checkApiError(<any>e);
    }
  }

  public async getCodigoBoleto(id) {
    const loadingNotification = { content: 'Copiando', showProgress: true };
    try {
      mainStore.addNotification(loadingNotification);
      const response = await api.getCodigoBoleto(mainStore.token, id);
      if (response) {
        navigator.clipboard.writeText(response.data);
        mainStore.removeNotification(loadingNotification);
        mainStore.addNotification({
          content: 'Código copiado com sucesso',
          color: 'success',
        });
      }
    } catch (error) {
      mainStore.removeNotification(loadingNotification);
      mainStore.addNotification({
        content: 'Ocorreu um erro ao copiar o código',
        color: 'error',
      });
      await mainStore.checkApiError(<any>error);
    }
  }

  public titleCase(txt: string) {
    return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
  }

  get statusSolicitacao() {
    return [
      {
        id: 1,
        descricao: 'Em atendimento',
      },
      {
        id: 2,
        descricao: 'Concluído',
      },
    ];
  }

  get franqueados() {
    //@ts-ignore
    return this.unidadeDetails.suporte.filter((item) => {
      if (item.cargo == 'FRANQUEADO') {
        return item;
      }
    });
  }

  get currentUser() {
    return mainStore.userProfile;
  }

  public async load() {
    if (!this.userProfile) return;

    if (this.propRetencaoItem.c014_id) {
      await cobrancaStore.getCobrancaDetails(this.propRetencaoItem.c014_id);
    } else {
      const c014_id = this.userProfile.company.c014_id;

      await cobrancaStore.getCobrancaDetails(c014_id);
    }
  }

  // public getTituloSerasaPago() {
  //   let item = this.titulosSerasa[1];
  //   //@ts-ignore
  //   item = item.filter((f) => f.titulo === this.tituloSerasaPago);
  //   //@ts-ignore
  //   return item[0].status_titulo;
  // }

  // public getTituloJudicialPago() {
  //   let item = this.titulosCobrancaJudicial[1];
  //   //@ts-ignore
  //   item = item.filter((f) => f.titulo === this.tituloJudicialPago);
  //   //@ts-ignore
  //   return item[0].status_titulo;
  // }

  public async mounted() {
    this.isLoading = true;

    const dataAtual = new Date();

    // Adicione 3 dias à data atual usando date-fns
    this.hojeMais3 = format(addDays(dataAtual, 3), 'yyyy-MM-dd');

    await mainStore.userProfile;

    await this.load();

    if (this.propRetencaoItem.c014_id > 0) {
      this.unidadeDetails = await companyStore.getCompanyByC014_id(String(this.propRetencaoItem.c014_id));
    }

    this.mensagens_titulos_syngoo = await retencaoFinanceiraStore.getMensagensEnviadasByC014_id(
      this.propRetencaoItem.c014_id
    );

    this.titulos_mensagem = this.mensagens_titulos_syngoo[0];
    this.res_titulos_mensagem = this.mensagens_titulos_syngoo[1];

    // this.titulosSerasa = await juridicoStore.getTitulosSerasa(
    //   this.propRetencaoItem.c014_id
    // );
    // this.titulosCobrancaJudicial = await juridicoStore.getTitulosCobranca(
    //   this.propRetencaoItem.c014_id
    // );

    this.textAviso =
      this.propDias === 0
        ? 'Aviso de títulos com vencimento hoje.'
        : 'Aviso de vencimento de títulos que vencem em 3 dias.';

    this.buscaTituloItems();

    this.isLoading = false;
  }
}
